import React from "react";
import { useNavigate } from 'react-router-dom';
import "./createSuccessfulChannel.css";
import axios from "./../../../../axios"

const CreateSuccessfulChannel = ({ isMember, successMsg, setOpenSuccessfull, change }) => {
  const navigate = useNavigate();
  let Teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const handleRefecthChannel = async () => {
    try {
      const res1 = await axios.get(
        `/api/v1/community/post/getByUserId/teacher/${Teacher_id}`
      );
      if (res1) {
        navigate("/CreateCommunity")
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className=" successful_create_transprant_body ">
        <div className=" p-2 successful_create_container shadow">
          <img src="images/Ellipse 208.svg" alt="" />
          {isMember ? (<span className=" my-4 successfully_create_message">
            Members added successfully.
          </span>) : (
            <span className=" my-4 successfully_create_message">
              {/* You have successfully created the channel */}
              {successMsg}
            </span>
          )}
          {/* <Link to={`/TotalCommuPost/${}}`} className="link"> */}
          <button
            onClick={() => {
              setOpenSuccessfull(false)
              change(false)
              handleRefecthChannel()
            }}
            className="btn btn-danger px-4 py-2 successfull_create_okay_btn"
          >
            Okay
          </button>
          {/* </Link> */}
        </div>
      </div>
    </>
  );
};

export default CreateSuccessfulChannel;
